import { FC } from "react";
import { faMap } from "@fortawesome/free-regular-svg-icons";
import orderOptimizerTranslationsHelper from "../../../../../../../../languages/order-optimizer-translations.helper";
import TableLinkButtonComponent from "../../../../../../../../common/components/table/button/link/table-link-button.component";
import {
  OrderOptimizerTaxiDetailsItemDriver,
  OrderOptimizerTaxiDetailsItemStepsOrders,
} from "../../../../common/types/order-optimizer-taxi-details-item";
import orderOptimizerTaxiDetailsHelper from "../../../../order-optimizer-taxi-details.helper";

type OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersStepSummaryProps =
  {
    driver: OrderOptimizerTaxiDetailsItemDriver | null;
    step: OrderOptimizerTaxiDetailsItemStepsOrders;
  };

const OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersStepSummaryComponent: FC<
  OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersStepSummaryProps
> = (props) => {
  const translations =
    orderOptimizerTranslationsHelper.getTaxiDetailsTranslations().table
      .centerTables;

  const totalDriverTime = props.step.totalTime;
  const totalHaltingTime = props.step.haltingTime;
  const totalDistance = props.step.distance;
  const lastPoint = props.step.points[props.step.points.length - 1];

  return (
    <div className="content">
      <div className="human_id" />
      <div className="address" title={translations.summaryLabel}>
        {translations.summaryLabel}
      </div>
      <div className="driver_time">
        {orderOptimizerTaxiDetailsHelper.getTimeDeltaLabel(totalDriverTime)}
      </div>
      <div
        className={`driver_halting_time ${totalHaltingTime < 0 ? "time_delayed" : ""}`}
      >
        {orderOptimizerTaxiDetailsHelper.getTimeDeltaLabel(totalHaltingTime)}
      </div>
      <div className="driver_distance">
        {orderOptimizerTaxiDetailsHelper.getDistanceLabel(totalDistance)}
      </div>
      <div className="actions">
        <TableLinkButtonComponent
          icon={faMap}
          openInNewTab
          to={orderOptimizerTaxiDetailsHelper.getGoogleMapsUrl(
            [lastPoint],
            props.driver?.startLat,
            props.driver?.startLon,
            false,
            true,
          )}
          type="primary"
        />
      </div>
    </div>
  );
};

export default OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersStepSummaryComponent;
